export default "__VITE_ASSET__DTYK3Joc__"